import { WSCard, WSList, WSText } from "@wingspanhq/fe-component-library";
import { PayrollWorkflowStrategy } from "@wingspanhq/payments/dist/interfaces";
import { queriesPayableRows } from "@query";
import React from "react";
import { useHistory } from "react-router-dom";
import { useBrowserPageTitle } from "../../../components/BrowserPageTitle/BrowserPageTitle";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryPayrollSettings } from "../../../query/payments/queries";
import { FilterableTablePayables } from "../components/TablePayables/FilterableTablePayables";
import { getTabFilter } from "../components/TablePayables/filters/request";

export const RoutePayablesToApprove: React.FC = () => {
  useBrowserPageTitle("Payables To Approve");
  const userId = useUserId();
  const history = useHistory();

  const payrollSettingsQuery = useQueryPayrollSettings(userId, {
    retry: false
  });
  const isDualStage =
    payrollSettingsQuery.data?.workflow === PayrollWorkflowStrategy.DualStage;

  const queryPayablesDraftSummary =
    queriesPayableRows.searchPayableRows.useQuery({
      page: { size: 1 },
      filter: getTabFilter("draft").filter
    });
  const draftCount = queryPayablesDraftSummary.data?.summary?.count ?? 0;

  return (
    <WSList gap="2XL">
      {draftCount > 0 && (
        <WSCard
          header={{
            label: {
              avatar: {
                type: "icon",
                icon: "alert-circle",
                size: "M",
                color: "amber400",
                colorBackground: "amber50"
              },
              text: "Draft payables"
            }
          }}
          divider="bottom"
          actions={{
            alignment: "left",
            buttons: [
              {
                label: "Manage draft payables",
                kind: "Link",
                rightIcon: "chevron-right",
                onClick: () => {
                  history.push("/member/invoices/payables/draft");
                }
              }
            ]
          }}
        >
          <WSText.ParagraphSm color="gray500">
            {draftCount} draft payable{draftCount > 1 ? "s" : ""}.
          </WSText.ParagraphSm>
        </WSCard>
      )}

      <FilterableTablePayables
        tab="to-approve"
        showDownloadCsv
        bulkActions={
          isDualStage
            ? ["approve", "unapprove", "cancel"]
            : ["approve", "cancel"]
        }
        visibleColumns={{
          payee: true,
          payableNumber: true,
          amount: true,
          dueDate: true,
          openedAt: true,
          status: true
        }}
        visibleFilters={{
          payeeId: true,
          payeeReviewStatus: true,
          openedDateRange: true,
          dueDateRange: true,
          bulkBatchId: true
        }}
        emptyState={{
          firstTime:
            "Every requested, scheduled, and paid payable will display here.",
          standart:
            "You’re all caught up! Nothing is waiting for your approval."
        }}
      />
    </WSList>
  );
};
